module.exports = __webpack_public_path__ + "static/media/skate-deck-pixelated.064b1d80.png";